<template lang="pug">
.sticker-purchase-root
  .spotlight_card.fw-b(v-if="paymentCompleteMobile === null")
    // Always show sticker/org details at top
    sticker-input-form(
      v-if="stickerDetails.campaignType !== 'Ticket'"
      :is-editable="isPurchaseAllowed ? editAmt : false"
      :show-form="isPurchaseAllowed ? !continuePayment : true"
      @edit-amt='editAmt = true'
      @input-amt='amt = $event'
      :userDetails='details',
      :stickerDetails='stickerDetails',
      :validationDetails='isPurchaseAllowed ? validationDetails : { isValid: true, errors: [] }'
    )
    ticket-input-form(
      v-else
      :is-editable="isPurchaseAllowed ? editAmt : false"
      :show-form="isPurchaseAllowed ? !continuePayment : true"
      @edit-amt='editAmt = true'
      @input-amt='amt = $event'
      :userDetails='details',
      :stickerDetails='stickerDetails',
      :validationDetails='isPurchaseAllowed ? validationDetails : { isValid: true, errors: [] }'
    )

    // Show error state when validation fails
    div(v-if="!isPurchaseAllowed")
      .bg-white.px-20.py-4
        .max-w-400.mx-auto.text-center
          .alert.alert-danger.mb-4(v-if="validationDetails.errors && validationDetails.errors.length > 0")
            div(v-for="error in validationDetails.errors" :key="error") {{ error }}

          .mb-4
            p.fs-16.fw-b.text-dark.mb-2 Unable to Complete Purchase
            p.fs-14.text-muted This sticker is currently unavailable for purchase. Please try again later or contact support if the issue persists.

          .d-flex.flex-column.align-items-center
            button.btn.btn-primary.mb-3(@click="goBack" style="width: 300px; max-width: 100%;") Go Back
            button.btn.btn-outline-secondary(@click="goHome" style="width: 300px; max-width: 100%;") Go Home

    // Show payment form when validation passes
    div(v-else)
      .pt-2.bg-gray-100(v-if="!continuePayment")
      div(v-show="!editAmt && !continuePayment").bg-white

        .px-20.mb-4.pt-4.fees-title(v-if="showContactInfo") Contact

          el-form(
            ref="refForm"
            :rules="rules"
            :model="unregisterInfo"
            status-icon
            label-position="top"
          )
            el-form-item(
              label="First Name"
              :prop="store.getters['users/me'] === null && !isAnonymous ? 'firstName' : ''"
            )
              el-input(v-model="unregisterInfo.firstName").input-field-payment

            el-form-item(
              label="Last Name"
              :prop="store.getters['users/me'] === null && !isAnonymous ? 'lastName' : ''"
            )
              el-input(v-model="unregisterInfo.lastName").input-field-payment

            el-form-item(label="Email" :prop="store.getters['users/me'] === null && !isAnonymous ? 'email' : ''")
              el-input(v-model="unregisterInfo.email" v-lowercase-email).input-field-payment

            el-form-item(label="Mobile phone number" prop="phone")
              el-input(
                v-model="unregisterInfo.phone"
                type="tel"
                placeholder="(123) 456-7890"
                v-mask="'(###) ###-####'"
              ).input-field-payment

            el-form-item(v-if="store.getters['users/me'] === null")
              el-checkbox(v-model="isAnonymous" label="Anonymous")
                | Anonymous
        .p-20.mb-4.fees-title Payment
          .max-w-350.mx-auto.mt-3
            p.input-filed-title Credit card
            div#payment-element
            div#card-errors.card_errors(role='alert', v-if='hasCardErrors') {{ cardErrors }}
        .pt-2.bg-gray-100.mb-4

        .px-20.py-4
          .max-w-300.mx-auto
            .fs-14.mb-4
              .d-flex.mb-2.fees-title
                div Subtotal
                .ms-auto ${{ parseFloat(amt).toFixed(2) }}
              .d-flex.mb-2.fees-title(v-if="amt >0")
                div Credit Card Fees (2.9% + ¢30)
                .ms-auto ${{ stripeFee.toFixed(2) }}
              .d-flex.mb-2.fees-title
                div Platform Fee (2%)
                .ms-auto ${{ convenienceFee.toFixed(2) }}

              .d-flex.fees-total-title
                div Total
                .ms-auto  ${{ (parseFloat(amt) + convenienceFee + stripeFee).toFixed(2) }}
          .max-w-300.mx-auto
            .mb-4.lh-sm
            i.fs-12.fw-m.opacity-50(v-if="stickerDetails.campaignType && stickerDetails.campaignType === 'Sweepstakes' && stickerDetails.sweepstakesSticker.checkoutPageLegal != null")  {{ stickerDetails.sweepstakesSticker.checkoutPageLegal.replace(/<[^>]*>/g, '') }}
          .max-w-300.mx-auto
            .mb-4.lh-sm
            i.fs-12.fw-r.opacity-50(v-if="getPaymentTextType() === 'ticket'" v-html="ticketStickerText")
            i.fs-12.fw-r.opacity-50(v-else-if="getPaymentTextType() === 'campaign'" v-html="v2CampaignText")
            i.fs-12.fw-r.opacity-50(v-else-if="getPaymentTextType() === 'sweepstakes'" v-html="sweepstakesText")
            i.fs-12.fw-r.opacity-50(v-else-if="getPaymentTextType() === 'free'" v-html="freeStickerText")
            i.fs-12.fw-m.opacity-50(v-else v-html="paidStickerText")
          .payment-footer-spacer
  .payment-fixed-footer(
    v-if="paymentCompleteMobile === null && isPurchaseAllowed && !editAmt && !continuePayment"
  )
    .pt-2.pb-0
      marketing-consent-checkbox(
        v-if="shouldShowConsentCheckbox"
        ref="consentCheckboxRef"
        :organization-name="stickerDetails.creatorTitle || 'the organization'"
        :organization-id="stickerDetails.entity === 'Organization' ? stickerDetails.entityId : null"
      )
      .mt-1
        el-button(type='success'
          v-loading='loading'
          round
          @click="finalizePayment").donate-button
          span(v-if="stickerDetails.campaignType && stickerDetails.campaignType === 'Campaign'") Confirm Donation
          span(v-else) Confirm Purchase
      .alert.alert-danger(v-if="error")
        | {{ errorMessage }}
      el-button(link round, @click.stop='cancelIntent').text-muted.donate-button Cancel
</template>

<script lang="ts">
import {
  computed, defineComponent, onMounted, reactive, ref,
} from 'vue';
import { useStore } from 'vuex';
import { mask } from 'vue-the-mask';
import { ElLoading } from 'element-plus';
import shared from './shared';
import lowercaseEmail from '@/directives/lowercase-email.js';
import {
  freeStickerText,
  paidStickerText,
  ticketStickerText,
  v2CampaignText,
  sweepstakesText,
} from '../../data/payment-text';
import StickerInputForm from './StickerInputForm.vue';
import TicketInputForm from './TicketInputForm.vue';
import MarketingConsentCheckbox from '@/components/MarketingConsentCheckbox.vue';
import globalShared from '@/shared';
import { email, phone, requiredRule } from '@/data/rules';
import {
  addEmbeddedContextToUrl,
  captureEmbedOrganizationContext,
  EMBED_HEIGHT_SYNC_EVENT,
  getEmbedNavigationHomeUrl,
  isEmbeddedContext,
  isStandaloneEmbedQuery,
  resolveEmbeddedUrl,
  scrollEmbedToTop,
} from '@/utils/embeddedUtils';
import { showPaymentSuccessModal } from '@/utils/paymentSuccessModal';
import { useFormScrolling } from '@/composables/useFormScrolling.js';
import { makeRequest } from '@/graphs/index';
import { hasActiveConsent, giveConsent } from '@/graphs/gql';

export default defineComponent({
  name: 'StickerPurchase',
  components: { StickerInputForm, TicketInputForm, MarketingConsentCheckbox },
  directives: { mask, lowercaseEmail },
  setup() {
    const {
      loading,
      route,
      requestCanIntent,
      requestCanIntentForOrg,
      requestCreateStickerPurchaseIntent,
      requestCanIntentForSticker,
      requestValidateIntentForSticker,
      requestValidateIntentForStickerPublic,
      requestCreateAnonymousStickerTransaction,
      requestStickerTicketEmailConfirmation,
      requestPurchaseAnonymousPaidSticker,
    } = shared();

    const { getMobileOperatingSystem, isSafari, handleSafariPrompt, getAuthToken } = globalShared();
    const { scrollToValidationError, scrollToPaymentSection } = useFormScrolling();

    const {
      userId, orgId, stickerId, causeId, variantIds, quantities,
    } = route.params;
    const {
      variantId,
      isWebUser,
      embedSource,
      glowId,
      returnTo,
      socialShopId,
      cost: queryCost,
      // variantIds,
      // quantities,
    } = route.query;

    // Extract embed parameters for embedded context
    const embedOrganizationId = ref(null);
    const embedHost = ref(null);
    const isStandaloneEmbed = ref(isStandaloneEmbedQuery(route.query));

    if (route.query.embedOrganizationId) {
      embedOrganizationId.value = route.query.embedOrganizationId;
    }

    if (route.query.embedSource) {
      embedHost.value = route.query.embedSource;
    } else if (embedSource) {
      embedHost.value = embedSource;
    }

    function getEmbedContextOverride(options?: { donationSuccess?: boolean }) {
      return {
        organizationId: embedOrganizationId.value,
        embedSource: embedHost.value,
        stickerId: String(stickerId || route.query.embedStickerId || ''),
        standalone: isStandaloneEmbed.value,
        donationSuccess: options?.donationSuccess,
      };
    }

    function navigateToEmbedHome(options?: { donationSuccess?: boolean }) {
      const homeUrl = getEmbedNavigationHomeUrl(getEmbedContextOverride(options));
      if (!homeUrl) {
        return false;
      }

      window.location.href = resolveEmbeddedUrl(homeUrl);
      return true;
    }

    const stickerDetails = reactive({});
    const validationDetails = reactive({});
    const refForm = ref(null);
    const consentCheckboxRef = ref(null);
    const readyToPay = ref(false);
    const hasCardErrors = ref(true);
    const cardErrors = ref('');
    const unregisterInfo = reactive({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
    });
    const isAnonymous = ref(false);
    let paymentElement;
    let stripe;
    let elements;

    const userOrOrg = ref('user');
    const amt = ref(0);

    const fee = ref(0);
    const convenienceFee = ref(0);
    const convenienceFeePercentageValue = ref(0);
    const stripeFee = ref(0);
    const editAmt = ref(true);
    const continuePayment = ref(false);
    const details = reactive({});
    const paymentIntent = reactive({});
    const paymentDetails = reactive({});
    const store = useStore();
    const paymentCompleteMobile = ref(null);
    const paymentSuccess = ref(false);
    const showContactInfo = ref(false);
    const completeUserInfo = ref(false);
    const error = ref(false);
    const errorMessage = ref('');
    const hasActiveConsentValue = ref(false);
    const isCheckingConsent = ref(true);

    function requestEmbedHeightSync(reason: string) {
      if (window.self === window.parent) {
        return;
      }

      window.dispatchEvent(new CustomEvent(EMBED_HEIGHT_SYNC_EVENT));
    }

    function loadStripe(stripeURL, callback) {
      const obj = document.createElement('script');
      const script = document.getElementsByTagName('script')[0];
      obj.src = `//${stripeURL}`;
      if (callback) {
        obj.addEventListener('load', (e) => {
          callback(null, e);
        }, false);
      }
      // console.log(obj.src);
      script.parentNode.insertBefore(obj, script);
    }

    function calculateFinalPayment(depositAmount) {
      let mTotalAmountWithConvenienceFee = 0;
      let mConvenienceFee = 0;
      const mConvenienceFeePercentageValue = 2.0; // Flat 2% for all transactions

      // Calculate 2% of deposit amount
      mConvenienceFee = parseFloat((0.02 * depositAmount).toFixed(2));

      // Cap convenience fee at $30
      if (mConvenienceFee > 30) {
        mConvenienceFee = 30;
      }

      mTotalAmountWithConvenienceFee = depositAmount + mConvenienceFee;

      // eslint-disable-next-line max-len
      const totalAmount = parseFloat(((mTotalAmountWithConvenienceFee + 0.30) / (1 - 0.029)).toFixed(2));
      const mStripeFee = parseFloat(totalAmount - mTotalAmountWithConvenienceFee).toFixed(2);

      const result = {
        total_amount: totalAmount,
        deposit_amount: depositAmount,
        convenienceFee: mConvenienceFee,
        convenienceFeePercentageValue: mConvenienceFeePercentageValue,
        creditCardFee: mStripeFee,
      };
      return result;
    }

    async function makeIntent() {
      let amount = parseFloat(parseFloat(amt.value).toFixed(2));
      if (route.query.cost && route.query.cost !== 'NA') {
        amount = parseFloat(route.query.cost);
      }

      if (amount >= 0) {
        let totalAmount = amount + fee.value;
        let response = '';
        let purchasedBy = 'User';

        if (userOrOrg.value === 'user') {
          purchasedBy = 'User';
        } else if (userOrOrg.value === 'org') {
          purchasedBy = 'Organization';
        }

        loading.value = true;
        const finalPaymentCalculation = calculateFinalPayment(parseFloat(amount));
        convenienceFee.value = finalPaymentCalculation.convenienceFee;
        stripeFee.value = parseFloat(parseFloat(finalPaymentCalculation.creditCardFee).toFixed(2));
        fee.value = parseFloat(parseFloat(convenienceFee.value + stripeFee.value).toFixed(2));
        convenienceFeePercentageValue.value = finalPaymentCalculation.convenienceFeePercentageValue;
        totalAmount = parseFloat(parseFloat(amount + fee.value).toFixed(2));

        if (amount === 0) {
          convenienceFee.value = 0;
          stripeFee.value = 0;
        }

        const paymentIntentInput = {
          purchaseBy: purchasedBy ?? 'User',
          stickerId: stickerDetails.id,
          userId: details.id ?? import.meta.env.VITE_ANONYMOUS_USER_ID,
          orgId: details.organizationId,
          causeId,
          variantId: `${variantIds}, ${quantities}`,
          cost: parseInt(amount),
          totalCost: totalAmount,
          totalFee: fee.value,
          convenienceFee: convenienceFee.value,
          creditCardFee: stripeFee.value,
          glowId: glowId || null,
          socialShopId: socialShopId || null,
        };

        response = await requestCreateStickerPurchaseIntent(paymentIntentInput);
        loading.value = false;

        if (await response !== '') {
          Object.assign(paymentDetails, JSON.parse(atob(response)));
          paymentDetails.amount = totalAmount;
          Object.assign(paymentIntent, paymentDetails);

          editAmt.value = false;
          loadStripe('js.stripe.com/v3/', () => {
            stripe = window.Stripe(paymentDetails.stripe_pub_key);
            elements = stripe.elements({ clientSecret: paymentDetails.client_secret });
            paymentElement = elements.create('payment');
            paymentElement.mount('#payment-element');
            paymentElement.on('ready', () => {
              requestEmbedHeightSync('stripe-ready');
            });
            paymentElement.on('change', (e) => {
              if (e.complete) {
                readyToPay.value = true;
                hasCardErrors.value = false;
              } else if (e.error) {
                hasCardErrors.value = true;
                readyToPay.value = false;
                cardErrors.value = e.error.message;
              }
            });
          });
          requestEmbedHeightSync('payment-intent-created');
        }
      }
    }

    function getRedirectUrl() {
      if (isWebUser === 'true') {
        return import.meta.env.VITE_WEB_BASE_URL;
      }
      return import.meta.env.VITE_APP_REDIRECT_BASE_URL;
    }

    function getRedirectIOSUrl() {
      if (isWebUser === 'true') {
        return import.meta.env.VITE_WEB_BASE_URL;
      }
      return import.meta.env.VITE_APP_REDIRECT_URL;
    }

    function buildCompleteProfileUrl(email) {
      const encodedEmail = encodeURIComponent(email);
      const baseUrl = `${getRedirectUrl()}/auth/web/complete-profile?email=${encodedEmail}`;

      let finalUrl = baseUrl;

      // If we have extracted embed parameters, add them manually
      if (embedOrganizationId.value || embedHost.value) {
        const url = new URL(baseUrl, window.location.origin);
        url.searchParams.set('embedded', 'true');

        if (embedOrganizationId.value) {
          url.searchParams.set('embedOrganizationId', embedOrganizationId.value);
        }
        if (embedHost.value) {
          url.searchParams.set('embedSource', embedHost.value);
        }
        if (isStandaloneEmbed.value) {
          url.searchParams.set('standalone', '1');
        }
        if (stickerId) {
          url.searchParams.set('embedStickerId', String(stickerId));
          url.searchParams.set('stickerId', String(stickerId));
        }

        finalUrl = url.toString();
      } else {
        finalUrl = addEmbeddedContextToUrl(baseUrl);
      }

      return resolveEmbeddedUrl(finalUrl);
    }

    function handleSuccessModalContinue(includeReturnTo = true) {
      const isLoggedIn = store.getters['users/me'] != null;

      if (
        isEmbeddedContext()
        && isLoggedIn
        && (embedOrganizationId.value || isStandaloneEmbed.value)
      ) {
        scrollEmbedToTop('payment-success-continue');
        navigateToEmbedHome({ donationSuccess: true });
        return;
      }

      let targetUrl = '';

      if (isLoggedIn) {
        if (glowId) {
          targetUrl = includeReturnTo && returnTo
            ? `${getRedirectUrl()}/web/glow/${glowId}?returnTo=${encodeURIComponent(returnTo)}`
            : `${getRedirectUrl()}/web/glow/${glowId}`;
        } else {
          const params = `action=purchaseSticker&amount=${amount}&success=true`;
          targetUrl = `${getRedirectUrl()}/web/stickers/purchased?${params}`;
        }
      } else {
        targetUrl = buildCompleteProfileUrl(unregisterInfo.email);
      }

      if (isEmbeddedContext()) {
        scrollEmbedToTop('payment-success-continue');
      }

      const resolvedUrl = resolveEmbeddedUrl(targetUrl);

      if (isLoggedIn) {
        if (glowId) {
          window.location.replace(resolvedUrl);
        } else {
          window.location.href = resolvedUrl;
        }
      } else {
        window.location.href = resolvedUrl;
      }
    }

    async function validateForm() {
      if (refForm.value) {
        return new Promise((resolve) => {
          refForm.value.validate(async (valid) => {
            if (valid) {
              completeUserInfo.value = true;
              resolve(true);
            } else {
              loading.value = false;
              completeUserInfo.value = false;

              // Scroll to the first validation error on smaller screens
              scrollToValidationError();

              resolve(false);
            }
          });
        });
      }
      return true; // If no form to validate, consider it valid
    }

    function showPaymentErrorModal(errorMessage, amount) {
      const errorModal = document.createElement('div');
      errorModal.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 9999;
        padding: 20px;
      `;

      const modalContent = document.createElement('div');
      modalContent.style.cssText = `
        background-color: white;
        border-radius: 12px;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
        padding: 40px;
        text-align: center;
        max-width: 90%;
        width: 450px;
        position: relative;
      `;

      const errorIcon = document.createElement('div');
      errorIcon.style.cssText = `
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background-color: rgba(245, 101, 101, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 24px auto;
      `;

      errorIcon.innerHTML = `<svg width="40" height="40" viewBox="0 0 24 24" fill="#f56565">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
      </svg>`;

      const title = document.createElement('h2');
      title.textContent = 'Payment Failed';
      title.style.cssText = `
        font-size: 24px;
        font-weight: 700;
        margin: 0 0 16px 0;
        color: #2d3748;
      `;

      const message = document.createElement('p');
      message.textContent = errorMessage || 'We encountered an error processing your payment. Please try again or contact support.';
      message.style.cssText = `
        font-size: 16px;
        line-height: 1.5;
        color: #718096;
        margin: 0 0 32px 0;
      `;

      const buttonContainer = document.createElement('div');
      buttonContainer.style.cssText = `
        display: flex;
        flex-direction: column;
        gap: 12px;
      `;

      const tryAgainButton = document.createElement('button');
      tryAgainButton.textContent = 'Try Again';
      tryAgainButton.style.cssText = `
        background-color: #1ebeaf;
        color: white;
        border: none;
        border-radius: 50px;
        padding: 12px 24px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s;
      `;

      tryAgainButton.addEventListener('mouseenter', () => {
        tryAgainButton.style.backgroundColor = '#19a89a';
      });

      tryAgainButton.addEventListener('mouseleave', () => {
        tryAgainButton.style.backgroundColor = '#1ebeaf';
      });

      tryAgainButton.addEventListener('click', () => {
        document.body.removeChild(errorModal);
        window.location.reload();
      });

      const cancelButton = document.createElement('button');
      cancelButton.textContent = 'Cancel';
      cancelButton.style.cssText = `
        background-color: transparent;
        color: #718096;
        border: 1px solid #e2e8f0;
        border-radius: 50px;
        padding: 12px 24px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s;
      `;

      cancelButton.addEventListener('mouseenter', () => {
        cancelButton.style.backgroundColor = '#f7fafc';
      });

      cancelButton.addEventListener('mouseleave', () => {
        cancelButton.style.backgroundColor = 'transparent';
      });

      cancelButton.addEventListener('click', () => {
        document.body.removeChild(errorModal);
        if (isWebUser === 'true') {
          const webFailedUrl = `${getRedirectUrl()}/web/sticker/${stickerId}`
            + `?action=purchaseSticker&amount=${amount}&success=false`;
          window.location.href = webFailedUrl;
        } else {
          redirectMobileApp(true);
        }
      });

      buttonContainer.appendChild(tryAgainButton);
      buttonContainer.appendChild(cancelButton);

      modalContent.appendChild(errorIcon);
      modalContent.appendChild(title);
      modalContent.appendChild(message);
      modalContent.appendChild(buttonContainer);
      errorModal.appendChild(modalContent);

      document.body.appendChild(errorModal);
    }

    async function finalizePayment(e) {
      loading.value = true;

      // First, validate the form - this takes priority over payment validation
      const isFormValid = await validateForm();
      if (!isFormValid) {
        // Form validation failed, loading was already set to false in validateForm()
        // and scrolling to the form error was already handled
        return;
      }

      // Submit consent if checkbox is checked
      await submitConsentIfChecked();

      localStorage.setItem('unregisterEmail', unregisterInfo.email);
      localStorage.setItem('unregisterPhone', unregisterInfo.phone);

      // Store metadata for tracking purposes
      const paymentMetadata = {
        email: unregisterInfo.email || store.getters['users/me']?.email || '',
        glowId: glowId || '',
        socialShopId: socialShopId || '',
        cost: amt.value,
        stickerId: stickerId || '',
        causeId: causeId || '',
        userId: userId || store.getters['users/me']?.id || '',
        timestamp: new Date().toISOString(),
      };
      localStorage.setItem('lastPaymentMetadata', JSON.stringify(paymentMetadata));

      // Construct return URL for bank account verification redirects
      const currentUrl = window.location.href;
      const returnUrl = currentUrl.split('?')[0] + (currentUrl.includes('?') ? `?${currentUrl.split('?')[1]}` : '');

      const stripePaymentData = {
        clientSecret: paymentIntent.client_secret,
        email: unregisterInfo.email || store.getters['users/me']?.email || '',
        glowId: glowId || '',
        socialShopId: socialShopId || '',
        cost: amt.value,
        stickerId: stickerId || '',
        causeId: causeId || '',
        userId: userId || store.getters['users/me']?.id || '',
        amount: parseFloat(amt.value).toFixed(2),
        totalAmount: (parseFloat(amt.value) + convenienceFee.value + stripeFee.value).toFixed(2),
      };

      await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: returnUrl,
          receipt_email: stripePaymentData.email || undefined,
          payment_method_data: {
            billing_details: {
              email: stripePaymentData.email || undefined,
            },
          },
        },
        redirect: 'if_required',
      }).then(async (result) => {
        const amount = parseFloat(amt.value).toFixed(2);

        if (result.error) {
          // For validation errors, let Stripe's field-level validation handle it
          // Don't show modal for field validation errors or missing required fields
          const validationErrors = [
            'incomplete_number', 'incomplete_expiry', 'incomplete_cvc',
            'invalid_number', 'invalid_expiry_month', 'invalid_expiry_year', 'invalid_cvc',
            'incomplete_email', 'invalid_email', 'incomplete_name', 'invalid_name',
            'incomplete_phone', 'invalid_phone', 'incomplete_address', 'invalid_address',
            'incomplete_zip', 'invalid_zip', 'parameter_missing', 'parameter_invalid_empty',
            'email_invalid', 'billing_details_invalid',
          ];

          // Check if this is a validation/form error that shouldn't show modal
          const isValidationError = result.error.code && validationErrors.includes(result.error.code);
          const isFormFieldError = result.error.type === 'validation_error'
                                   || result.error.message?.toLowerCase().includes('email')
                                   || result.error.message?.toLowerCase().includes('name')
                                   || result.error.message?.toLowerCase().includes('phone');

          if (isValidationError || isFormFieldError) {
            loading.value = false;
            scrollToPaymentSection();
            return;
          }

          // For other errors (card declined, network issues, bank account issues), show error modal
          loading.value = false;
          showPaymentErrorModal(result.error.message, amount);
          return;
        }

        const { paymentIntent } = result;

        // await requestCreateAnonymousStickerTransaction(
        //   paymentIntent.id,
        //   paymentIntent.client_secret,
        //   unregisterInfo.email,
        //   unregisterInfo.phone.replace(/[^\d]/g, '')
        // );

        // Only call API for non-authenticated web users (not mobile users)
        if (store.getters['users/me'] === null && isWebUser === 'true') {
          const anonymousUserData = {
            intentId: paymentIntent.id,
            clientSecret: paymentIntent.client_secret,
            email: isAnonymous.value ? '' : unregisterInfo.email,
            phone: unregisterInfo.phone.replace(/[^\d]/g, ''),
            firstName: unregisterInfo.firstName,
            lastName: unregisterInfo.lastName,
            embedOrganizationId: embedOrganizationId.value,
            embedHost: embedHost.value,
          };

          await requestPurchaseAnonymousPaidSticker(
            paymentIntent.id,
            paymentIntent.client_secret,
            isAnonymous.value ? '' : unregisterInfo.email,
            unregisterInfo.phone.replace(/[^\d]/g, ''),
            unregisterInfo.firstName,
            unregisterInfo.lastName,
            embedOrganizationId.value,
            embedHost.value,
          );
        }

        // await sendEmail(paymentIntent);

        if (result?.paymentIntent?.status === 'succeeded') {
          if (store.getters['sticker/HAS_FETCHED_PURCHASED_STICKERS']) {
            const currentStickers = [...store.getters['sticker/GET_PURCHASED_STICKERS']];
            if (!currentStickers.some((s) => s.id === stickerDetails.id)) {
              currentStickers.unshift(stickerDetails);
              store.dispatch('sticker/SET_PURCHASED_STICKERS', currentStickers);
            }
          }

          // Show a success message to your customer
          // There's a risk of the customer closing the window before callback
          // execution. Set up a webhook or plugin to listen for the
          // payment_intent.succeeded event that handles any business critical
          // post-payment actions.

          paymentSuccess.value = true;
          if (isWebUser === 'true') {
            if (stickerDetails.campaignType && stickerDetails.campaignType === 'Campaign') {
              showPaymentSuccessModal({
                title: 'Thank You for Your Donation!',
                message: 'Your generous donation has been received. The funds will support our mission.',
                iconVariant: 'green',
                onContinue: () => handleSuccessModalContinue(),
              });
            } else {
              showPaymentSuccessModal({
                title: 'Purchase Successful!',
                message: 'Your sticker has been added to your collection. Thank you for your purchase!',
                iconVariant: 'blue',
                onContinue: () => handleSuccessModalContinue(),
              });
            }
          } else {
            redirectMobileApp();
          }
        } else if (['processing', 'requires_action', 'requires_confirmation'].includes(result?.paymentIntent?.status)) {
          // For bank payments, these statuses are normal and should be treated as success
          paymentSuccess.value = true;

          if (isWebUser === 'true') {
            showPaymentSuccessModal({
              title: stickerDetails.campaignType === 'Campaign'
                ? 'Thank You for Your Donation!'
                : 'Payment Processing!',
              message: 'Your bank payment is being processed. You will receive a confirmation email once completed.',
              iconVariant: 'blue',
              onContinue: () => handleSuccessModalContinue(false),
            });
          } else {
            redirectMobileApp();
          }
        } else if (['canceled', 'requires_payment_method', 'payment_failed'].includes(result?.paymentIntent?.status)) {
          // Only show modal for actual payment failures, not validation issues
          const errorModal = document.createElement('div');
          errorModal.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 9999;
            padding: 20px;
          `;

          const modalContent = document.createElement('div');
          modalContent.style.cssText = `
            background-color: white;
            border-radius: 12px;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
            padding: 40px;
            text-align: center;
            max-width: 90%;
            width: 450px;
            position: relative;
          `;

          const errorIcon = document.createElement('div');
          errorIcon.style.cssText = `
            width: 80px;
            height: 80px;
            border-radius: 50%;
            background-color: rgba(245, 101, 101, 0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 24px auto;
          `;

          errorIcon.innerHTML = `<svg width="40" height="40" viewBox="0 0 24 24" fill="#f56565">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
          </svg>`;

          const title = document.createElement('h2');
          title.textContent = 'Payment Failed';
          title.style.cssText = `
            font-size: 24px;
            font-weight: 700;
            margin: 0 0 16px 0;
            color: #2d3748;
          `;

          const message = document.createElement('p');
          message.textContent = 'We encountered an error processing your payment. Please try again or contact support.';
          message.style.cssText = `
            font-size: 16px;
            line-height: 1.5;
            color: #718096;
            margin: 0 0 32px 0;
          `;

          const buttonContainer = document.createElement('div');
          buttonContainer.style.cssText = `
            display: flex;
            flex-direction: column;
            gap: 12px;
            
            @media (min-width: 480px) {
              flex-direction: row;
              justify-content: center;
            }
          `;

          const tryAgainButton = document.createElement('button');
          tryAgainButton.textContent = 'Try Again';
          tryAgainButton.style.cssText = `
            background-color: #1ebeaf;
            color: white;
            border: none;
            border-radius: 50px;
            padding: 12px 24px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            transition: background-color 0.2s;
            margin-bottom: 12px;
            
            @media (min-width: 480px) {
              margin-bottom: 0;
              margin-right: 12px;
            }
          `;

          tryAgainButton.addEventListener('mouseenter', () => {
            tryAgainButton.style.backgroundColor = '#19a89a';
          });

          tryAgainButton.addEventListener('mouseleave', () => {
            tryAgainButton.style.backgroundColor = '#1ebeaf';
          });

          tryAgainButton.addEventListener('click', () => {
            document.body.removeChild(errorModal);
            window.location.reload();
          });

          const cancelButton = document.createElement('button');
          cancelButton.textContent = 'Cancel';
          cancelButton.style.cssText = `
            background-color: transparent;
            color: #718096;
            border: 1px solid #e2e8f0;
            border-radius: 50px;
            padding: 12px 24px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            transition: background-color 0.2s;
          `;

          cancelButton.addEventListener('mouseenter', () => {
            cancelButton.style.backgroundColor = '#f7fafc';
          });

          cancelButton.addEventListener('mouseleave', () => {
            cancelButton.style.backgroundColor = 'transparent';
          });

          cancelButton.addEventListener('click', () => {
            document.body.removeChild(errorModal);
            if (isWebUser === 'true') {
              const webFailedUrl = `${getRedirectUrl()}/web/sticker/${stickerId}`
                + `?action=purchaseSticker&amount=${amount}&success=false`;
              window.location.href = webFailedUrl;
            } else {
              redirectMobileApp(true); // Pass true to indicate payment failed
            }
          });

          buttonContainer.appendChild(tryAgainButton);
          buttonContainer.appendChild(cancelButton);

          modalContent.appendChild(errorIcon);
          modalContent.appendChild(title);
          modalContent.appendChild(message);
          modalContent.appendChild(buttonContainer);
          errorModal.appendChild(modalContent);

          document.body.appendChild(errorModal);
        }
      }).finally(() => {
        loading.value = false;
      });
    }

    async function redirectMobileApp(failed = false) {
      const amount = parseFloat(amt.value).toFixed(2);
      const loadingInstance = ElLoading.service({
        lock: false,
      });
      const isAndroid = getMobileOperatingSystem() === 'Android';
      const appId = import.meta.env.VITE_APP_ID;
      const appHost = import.meta.env.VITE_APP_HOST;
      const browserFallbackUrlBase = import.meta.env.VITE_WEB_BASE_URL;
      const browserFallbackUrlPath = 'web/dashboard';

      // Determine success status based on payment outcome and failed parameter
      let success;
      if (failed) {
        success = 'false';
      } else {
        success = (paymentSuccess.value).toString();
      }

      // Check if user checked the consent checkbox
      let giveConsent = 'false';
      let orgId = '';
      if (shouldShowConsentCheckbox.value && consentCheckboxRef.value) {
        const isConsentChecked = consentCheckboxRef.value.getConsentValue();
        giveConsent = isConsentChecked ? 'true' : 'false';
        
        // Get organization ID for consent
        if (stickerDetails.entity === 'Organization') {
          orgId = stickerDetails.entityId || '';
        }
      }

      if (isAndroid) {
        const encodedBrowserFallbackUrl = encodeURIComponent(
          `${browserFallbackUrlBase}/${browserFallbackUrlPath}`,
        );
        let intentUrl = `intent://${appHost}/?action=purchaseSticker&amount=${amount}&success=${success}&giveConsent=${giveConsent}`;
        
        // Add orgId if consent was checked
        if (giveConsent === 'true' && orgId) {
          intentUrl += `&orgId=${orgId}`;
        }
        
        intentUrl += `#Intent;scheme=${appId};package=${appId};S.browser_fallback_url=${encodedBrowserFallbackUrl};end`;
        
        window.location.href = intentUrl;
      } else {
        // iOS redirect
        let iosUrl = `${getRedirectIOSUrl()}?action=purchaseSticker&amount=${amount}&success=${success}&giveConsent=${giveConsent}`;
        
        // Add orgId if consent was checked
        if (giveConsent === 'true' && orgId) {
          iosUrl += `&orgId=${orgId}`;
        }
        
        window.location.href = iosUrl;
      }

      paymentCompleteMobile.value = true;

      // Detect if redirect was successful
      let didSafariRedirect = false;
      if (isSafari()) {
        didSafariRedirect = await handleSafariPrompt();
      }

      // we are checking for strong inequality with false, because null indicates that the prompt timed out, not that the redirection was unsuccessful
      // unfortunately this will attempt to redirect the user to the app store if they decline the redirect to the app on Safari
      // currently no better option exists for iOS Safari
      if (!isSafari() || didSafariRedirect !== false) {
        setTimeout(() => {
          // redirect user to the dashboard if the document is hidden (i.e. the app launched successfully)
          if (document.hidden) {
            window.location.href = `${browserFallbackUrlBase}/${browserFallbackUrlPath}`;
            loadingInstance.close();
          }
          // keep user on site to allow redirect with button
          else {
            loadingInstance.close();
          }
        }, 1500);
      }
      // iOS Safari failed redirect
      else {
        loadingInstance.close();
      }
    }

    function continueToPayment(e) {
      e.preventDefault();
      continuePayment.value = true;
    }

    async function getUserIntent() {
      loading.value = true;
      const response = await requestCanIntent(userId);
      Object.assign(details, response);
      loading.value = false;
    }

    async function getOrgIntent() {
      loading.value = true;
      const response = await requestCanIntentForOrg(userId, orgId);
      Object.assign(details, response);
      loading.value = false;
    }

    async function getStickerIntent() {
      loading.value = true;
      const response = await requestCanIntentForSticker(stickerId);

      Object.assign(stickerDetails, response);

      // Determine entity type and ID
      let entityType;
      let entityId;

      if (userOrOrg.value === 'user') {
        entityType = 'User';
        entityId = userId;
      } else if (userOrOrg.value === 'org') {
        entityType = 'Organization';
        entityId = orgId;
      } else {
        // No userId/orgId in route - use logged-in user if available
        if (store.getters['users/me'] !== null) {
          entityType = 'User';
          entityId = store.getters['users/me'].id;
        } else {
          // Anonymous user - will use public validation below
          entityType = 'User';
          entityId = undefined;
        }
      }

      // Safety check: ensure entityId is set for logged-in users
      if (!entityId && store.getters['users/me'] !== null) {
        entityId = store.getters['users/me'].id;
      }

      if (store.getters['users/me'] !== null || isWebUser !== 'true') {
        if (entityId) {
          const validateResponse = await requestValidateIntentForSticker(stickerId, entityType, entityId);
          Object.assign(validationDetails, validateResponse);
        } else {
          // Fall back to anonymous validation
          const validateResponse = await requestValidateIntentForSticker(stickerId, 'User', import.meta.env.VITE_ANONYMOUS_USER_ID);
          showContactInfo.value = true;
          Object.assign(validationDetails, validateResponse);
        }
      } else {
        const validateResponse = await requestValidateIntentForSticker(stickerId, 'User', import.meta.env.VITE_ANONYMOUS_USER_ID);
        showContactInfo.value = true;
        Object.assign(validationDetails, validateResponse);
      }
      loading.value = false;
    }

    function cancelIntent() {
      if (embedOrganizationId.value || isStandaloneEmbed.value) {
        navigateToEmbedHome();
        return;
      }

      // Default behavior for non-embed mode
      if (isWebUser === 'true') {
        window.location.href = `${getRedirectUrl()}/web/sticker/${stickerId}`;
      } else {
        window.location.href = `${getRedirectUrl()}?action=StickerPurchaseCancel`;
      }
    }

    function goBack() {
      if (embedOrganizationId.value || isStandaloneEmbed.value) {
        navigateToEmbedHome();
        return;
      }

      // Try to go back in history, or fallback to sticker details page
      if (window.history.length > 1) {
        window.history.back();
      } else if (isWebUser === 'true') {
        window.location.href = `${getRedirectUrl()}/web/sticker/${stickerId}`;
      } else {
        window.location.href = getRedirectUrl();
      }
    }

    function goHome() {
      if (embedOrganizationId.value || isStandaloneEmbed.value) {
        navigateToEmbedHome();
        return;
      }

      // Navigate to home page
      if (isWebUser === 'true') {
        window.location.href = `${getRedirectUrl()}/web`;
      } else {
        window.location.href = getRedirectUrl();
      }
    }

    const sendEmail = async (paymentIntent) => {
      const descriptions = createEmailDescriptions();
      let email = route.query?.email || '';
      email = email.replace(/ /g, '+');
      const name = details.firstname || '';
      const userId = route.params?.userId ?? '';
      const stickerId = route.params?.stickerId ?? '';
      return requestStickerTicketEmailConfirmation(descriptions, email, name, paymentIntent.id, paymentIntent.client_secret, userId, stickerId);
    };

    const createEmailDescriptions = () => {
      // description[ticket description]  | unit price  | quantity | amount [total]
      if (stickerDetails.campaignType === 'Ticket') {
        return buildTicketDescriptions();
      }
      return buildStickerDescriptions();
    };

    const buildTicketDescriptions = () => {
      const variantIds = route.params.variantIds?.split(',');
      const quantities = route.params.quantities?.split(',');
      const descriptions = [];

      stickerDetails.varients.map((variant) => {
        if (variantIds?.includes(variant.id)) {
          const index = variantIds.indexOf(variant.id);
          const quantity = Number(quantities[index]);
          const totalAmount = variant.cost * quantity;

          const description = {
            title: stickerDetails.title,
            description: stickerDetails.description,
            ticketDescription: variant.description,
            unitPrice: variant.cost,
            quantity,
            totalAmount,
          };
          descriptions.push(description);
        }
      });
      return descriptions;
    };

    const buildStickerDescriptions = () => [
      {
        title: stickerDetails.title,
        description: stickerDetails.description,
        ticketDescription: '',
        unitPrice: stickerDetails.cost,
        quantity: 1,
        totalAmount: stickerDetails.cost,
      },
    ];

    // _____check if payment button should be shown_____
    const showPaymentButton = computed(() => {
      if (isWebUser !== 'true' || (store.getters['users/me'] != null && unregisterInfo.email === '' && unregisterInfo.phone === '')) {
        return true;
      }
      if (store.getters['users/me'] === null) {
        // For anonymous users, always show button (they can purchase without email)
        if (isAnonymous.value) {
          return true;
        }
        // For non-anonymous users, always show button but validation will happen on click
        // This allows users to see validation errors when they try to purchase
        return true;
      }
      return false;
    });

    const isPurchaseAllowed = computed(() => {
      // Block purchase if validation fails
      if (validationDetails.isValid === false) {
        return false;
      }
      return true;
    });

    function calculateAmount() {
      let calculatedAmt = 0;
      for (let i = 0; i < variantIds.length; i++) {
        const variantId = variantIds[i];
        const quantity = quantities[i];

        const variant = stickerDetails.variants.find((v) => v.id === variantId);
        if (variant) {
          calculatedAmt += variant.price * quantity;
        }
      }
      if (route.query.cost && route.query.cost !== 'NA') {
        calculatedAmt = parseFloat(route.query.cost);
      }
      amt.value = calculatedAmt;
    }

    function getPaymentTextType() {
      // Check campaign type first for specific types
      if (stickerDetails.campaignType === 'Ticket') {
        return 'ticket';
      }
      if (stickerDetails.campaignType === 'Campaign') {
        return 'campaign';
      }
      if (stickerDetails.campaignType === 'Sweepstakes') {
        return 'sweepstakes';
      }

      // Check if it's a free sticker (amount is 0)
      const currentAmount = parseFloat(amt.value) || 0;
      if (currentAmount === 0) {
        return 'free';
      }

      // Default to paid sticker
      return 'paid';
    }

    async function checkActiveConsent() {
      // Get organization ID based on sticker entity type
      let organizationId = null;
      if (stickerDetails.entity === 'Organization') {
        organizationId = stickerDetails.entityId;
      }

      if (!organizationId) {
        // No organization, skip consent check
        isCheckingConsent.value = false;
        return;
      }

      // Check if mobile app provided hasConsent status via URL
      if (route.query.hasConsent !== undefined) {
        // Mobile app already checked consent status and passed it to us
        hasActiveConsentValue.value = route.query.hasConsent === 'true';
        isCheckingConsent.value = false;
        return;
      }

      // Check if user is logged in
      const me = store.getters['users/me'];

      if (!me || !me.token) {
        // Anonymous user without hasConsent param - show checkbox by default
        hasActiveConsentValue.value = false;
        isCheckingConsent.value = false;
        return;
      }

      try {
        const token = me.token;
        const response = await makeRequest(
          'query',
          hasActiveConsent,
          { orgId: organizationId },
          { token },
        );

        if (response?.errors) {
          // On error, assume no consent and show checkbox
          hasActiveConsentValue.value = false;
        } else {
          hasActiveConsentValue.value = response?.data?.hasActiveConsent || false;
        }
      } catch (error) {
        console.error('Error checking consent:', error);
        // On error, assume no consent and show checkbox
        hasActiveConsentValue.value = false;
      } finally {
        isCheckingConsent.value = false;
      }
    }

    async function submitConsentIfChecked() {
      // Check if consent checkbox is shown and checked
      if (!shouldShowConsentCheckbox.value) {
        return;
      }

      if (!consentCheckboxRef.value) {
        return;
      }

      const isConsentChecked = consentCheckboxRef.value.getConsentValue();

      if (!isConsentChecked) {
        return;
      }

      // Get organization ID
      let organizationId = null;
      if (stickerDetails.entity === 'Organization') {
        organizationId = stickerDetails.entityId;
      }

      if (!organizationId) {
        return;
      }

      // Check if user is logged in
      const me = store.getters['users/me'];
      
      if (!me || !me.token) {
        // Anonymous user - consent will be passed to mobile app via URL parameters
        return;
      }

      try {
        const { token } = me;

        const response = await makeRequest(
          'mutation',
          giveConsent,
          { orgId: organizationId },
          { token },
        );

        if (response?.errors) {
          console.error('Error submitting consent:', response.errors);
          // Don't block payment if consent fails
        } else {
          hasActiveConsentValue.value = true;
        }
      } catch (error) {
        console.error('Failed to submit consent:', error);
        // Don't block payment if consent fails
      }
    }

    const shouldShowConsentCheckbox = computed(() => {
      // Get organization ID based on sticker entity type
      let organizationId = null;
      if (stickerDetails.entity === 'Organization') {
        organizationId = stickerDetails.entityId;
      }

      // Don't show if still checking
      if (isCheckingConsent.value) {
        return false;
      }

      // Don't show if user already has active consent
      if (hasActiveConsentValue.value) {
        return false;
      }

      // Don't show if there's no organization (only show for organization stickers)
      if (!organizationId) {
        return false;
      }

      // Show checkbox
      return true;
    });

    onMounted(async () => {
      if (route.query.embedOrganizationId || route.query.embedStickerId || route.query.standalone) {
        captureEmbedOrganizationContext({
          query: route.query,
          path: route.path,
          fullPath: route.fullPath,
        });
      }

      if (userId && orgId) {
        userOrOrg.value = 'org';
        await getOrgIntent();
      } else if (userId && !orgId) {
        userOrOrg.value = 'user';
        await getUserIntent();
      } else {
        userOrOrg.value = 'false';
      }
      await getStickerIntent();
      await makeIntent();

      if (route.query.cost && route.query.cost !== 'NA') {
        amt.value = parseFloat(route.query.cost);
      }

      // Check for active consent after sticker details are loaded
      await checkActiveConsent();
      requestEmbedHeightSync('sticker-purchase-mounted');
      // calculateAmount ();
    });

    return {
      refForm,
      consentCheckboxRef,
      amt,
      fee,
      convenienceFee,
      stripeFee,
      convenienceFeePercentageValue,
      paymentIntent,
      editAmt,
      continuePayment,
      unregisterInfo,
      showContactInfo,
      loading,
      makeIntent,
      requestCanIntent,
      requestCanIntentForOrg,
      readyToPay,
      hasCardErrors,
      cardErrors,
      paymentDetails,
      finalizePayment,
      redirectMobileApp,
      buildCompleteProfileUrl,
      cancelIntent,
      details,
      continueToPayment,
      freeStickerText,
      paidStickerText,
      ticketStickerText,
      v2CampaignText,
      sweepstakesText,
      getPaymentTextType,
      stickerDetails,
      validationDetails,
      isWebUser,
      paymentCompleteMobile,
      paymentSuccess,
      validateForm,
      scrollToValidationError,
      scrollToPaymentSection,
      rules: {
        firstName: requiredRule('First Name'),
        lastName: requiredRule('Last Name'),
        email,
        phone,
      },
      showPaymentButton,
      isPurchaseAllowed,
      isAnonymous,
      store,
      error,
      errorMessage,
      goBack,
      goHome,
      hasActiveConsentValue,
      isCheckingConsent,
      shouldShowConsentCheckbox,
    };
  },
});
</script>
<style scoped>
.el-form-item {
  margin-bottom: 12px !important;
}
.fees-section {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

/* Fixed footer for agreement text and action buttons */
.payment-fixed-footer {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 400px;
  z-index: 50;
  background-color: #fff;
  padding-left: 8px;
  padding-right: 8px;
}

/* Spacer that compensates for the height of the fixed footer */
.payment-footer-spacer {
  height: 200px;
}

/* Error state button styling */
.btn {
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.2s ease;
  border: 2px solid transparent;
  cursor: pointer;
}

.btn-primary {
  background-color: #4A90E2;
  color: white;
  border-color: #4A90E2;
}

.btn-primary:hover {
  background-color: #357ABD;
  border-color: #357ABD;
}

.btn-outline-secondary {
  background-color: white;
  color: #6c757d;
  border-color: #dee2e6;
}

.btn-outline-secondary:hover {
  background-color: #f8f9fa;
  color: #495057;
  border-color: #adb5bd;
}
</style>
